export const INTERCOM_SCRIPT_ID = 'intercom-widget';

/**
 * Opt-out cookie (`intercom-disabled=true`) that environments such as QA set to keep the
 * Messenger, and so product tours, from launching.
 */
export const INTERCOM_DISABLED_COOKIE = 'intercom-disabled';

/**
 * Intercom's own default host, so leaving `INTERCOM_API_BASE` unset behaves like the vanilla
 * snippet instead of silently sending `api_base: undefined`. Override it for a workspace hosted
 * outside the US (`https://api-iam.eu.intercom.io`, `https://api-iam.au.intercom.io`) — the
 * Messenger authenticates against the wrong region otherwise.
 */
export const DEFAULT_INTERCOM_API_BASE = 'https://api-iam.intercom.io';

export const intercomWidgetUrl = (appId: string): string =>
  `https://widget.intercom.io/widget/${appId}`;
